import Cookies from 'js-cookie';

// Imported straight from the leaf module, not the '@share/constants' barrel, so the
// purge can run before the rest of the app is evaluated (see src/purge-mbr-token.ts).
import { COOKIE_TOKEN_NAME, COOKIE1_TOKEN_NAME } from '../constants/common';

const MBR_TOKEN_COOKIES = [COOKIE_TOKEN_NAME, COOKIE1_TOKEN_NAME];

/**
 * True only in the build deployed on the travcoding.com production machine
 * (`npm run build:travcoding`). That deployment must never accept a member
 * token: the mbr cookies are shared across every *.travcoding.com host, so a token
 * handed out for QA would otherwise also work on production.
 */
export const isMbrTokenPurgeEnabled = (): boolean => import.meta.env.VITE_PURGE_MBR_TOKEN === 'true';

/**
 * Every Domain attribute the cookie could have been written with for this host: the
 * host itself and each of its parent domains (bookingflow.travcoding.com,
 * travcoding.com). The cookie is set by an external party, so its scope is not
 * known in advance; a browser only deletes a cookie whose name, domain and path all
 * match, so each candidate is tried.
 */
const candidateDomains = (hostname: string): string[] => {
  const labels = hostname.split('.');
  const domains: string[] = [];
  for (let i = 0; i < labels.length - 1; i++) {
    domains.push(labels.slice(i).join('.'));
  }
  return domains;
};

/**
 * Removes the member token cookies from the browser. Because they live on the shared
 * travcoding.com domain this also removes them for every other environment in this
 * browser: anyone who lands here has to get a new token to go back to QA. That is
 * intended.
 */
export const purgeMbrTokenCookies = (): void => {
  if (!isMbrTokenPurgeEnabled() || typeof window === 'undefined') {
    return;
  }

  const domains = candidateDomains(window.location.hostname);
  MBR_TOKEN_COOKIES.forEach((name) => {
    Cookies.remove(name, { path: '/' });
    domains.forEach((domain) => Cookies.remove(name, { path: '/', domain }));
  });
};
